















// @ts-ignore
import radialProgressBar from "vue-radial-progress";
import { computed } from "@vue/composition-api";

export default {
    components: {
        radialProgressBar,
    },
    props: {
        deliveryStats: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const getDeliveredCount = computed(() => Number(props.deliveryStats?.delivered) ?? 0);
        const getTotalContactsCount = computed(() => Number(props.deliveryStats?.total));

        const getDeliveredRatio = computed(
            () => Math.round((getDeliveredCount.value / getTotalContactsCount.value) * 1000) / 10 || 0
        );
        return {
            getDeliveredRatio,
            getTotalContactsCount,
            getDeliveredCount,
        };
    },
};
